export const clubReducer = (
	state = {
		list: undefined,
		count: 0,
		clubData: [],
		clubDetails: undefined,
		detail: undefined,
	},
	action
) => {
	switch (action.type) {
		case "CLUB_LIST_SUCCESS":
		case "CLUB_SEARCH_SUCCESS":
			return {
				...state,
				list: action.payload.list,
				count: action.payload.count,
				clubData: action.payload.clubData,
			};
		case "CLUB_DETAILS":
			return {
				...state,
				clubDetails: action.payload,
			};

		case "CLUB_TOGGLE_SUCCESS":
			return {
				...state,
				clubDetails: { ...state?.clubDetails, isActive: !state?.clubDetails?.isActive },
			};
		case "CLUB_SEARCH_CLEAR":
			return {
				...state,
				list: undefined,
				count: 0,
			};
		default:
			return state;
	}
};
